import {
  FAIL_CONNECTION,
  STOP_FETCHING,
  UPDATE_CONNECTION,
  INIT_CONNECTION,
  INIT_CHECK_CONNECTION,
  RESET_CONNECTION_STATUS,
} from "../actions/connection";

const connectionInitialState = {
  message: null,
  status: null,
  fetching: false,
};

const connectionReducer = (state = connectionInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "LOGOUT_STORE":
    case RESET_CONNECTION_STATUS:
      return {
        ...connectionInitialState,
      };
    case INIT_CONNECTION:
      return {
        message: "Starting connection...",
        status: "WAITING",
        fetching: true,
      };
    case INIT_CHECK_CONNECTION:
      return {
        ...state,
        fetching: true,
      };
    case STOP_FETCHING:
      return {
        ...state,
        fetching: false,
      };
    case UPDATE_CONNECTION:
      return {
        ...action.payload,
        fetching: false,
      };
    case FAIL_CONNECTION:
      return {
        message: "Unable to connect to customer wifi",
        status: "FAILED",
        fetching: false,
      };
    default:
      return state;
  }
};

export default connectionReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/connection.js